import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import * as Company from './Company';
import * as TicketLabel from './TicketLabel';
import * as UserToCompany from './UserToCompany';

export type BaseView = {
  '@id': string;
  '@type': 'User';
  id: string;
  agencyRole: string | null;
  firstName: string;
  lastName: string;
  skills: Array<string> | null;
};

export type V_Self = BaseView & {
  email: string;
  notifyTicket: boolean | null;
  userToCompanies: Array<
    UserToCompany.BaseView & {
      company: Company.BaseView & {
        ticketLabels: Array<TicketLabel.BaseView>;
      };
    }
  >;
};

export type W_partial = Partial<{
  plainPassword: string | null;
  notifyTicket: boolean | null;
}>;

export function useReadCollectionAgency(options?: ReadConfig) {
  return useApiRead<HydraCollection<BaseView>>(`/users/agency`, options);
}

export function useReadCollectionListCompanySub(
  companyId: string,
  options?: ReadConfig
) {
  return useApiRead<HydraCollection<BaseView>>(
    `/companies/${companyId}/users`,
    options
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<BaseView>(`/users/${id}`, options);
}

export function useReadItemSelf(id: string, options?: ReadConfig) {
  return useApiRead<V_Self>(`/users/${id}/self`, options);
}
